<script>
import { McWysiwyg } from '@mycure/vue-wysiwyg';
import {mapGetters, mapActions} from 'vuex'

import pfMixin from '../../../../mixins/pfMixin'
export default {
	mixins: [pfMixin],
	components: {
		McWysiwyg,
		PfModal: () => import(/* webpackChunkName: "pf-modal" */ '../PfModal'),
		PfLoader: () => import(/* webpackChunkName: "pf-loader" */ '../PfLoader'),
	},
	props: ['client', 'analysis', 'name'],

	data() {
		return {
			cliente: null,
			activeClient: null,
			datos: {
			},
			modalNewAnalysis: {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			},
			config: {
				events: {
					initialized: function () {
						console.log('initialized')
					}
				}
			},
			model: 'Edit Your Content Here!',
			hide: {
				strikethrough: true,
				table: true
			}
		}
	},

	computed: {
		totalAccionistas() {
			let total = 0

			this.datos.principales_accionistas.forEach(a => {
				total += Number(a.porcentaje)
			})

			return total
		},
		...mapGetters({
			pfSearch: 'pfClients/search',
			userId: 'auth/userId',
		})
	},

	watch: {
		client: {
			handler(newData, oldData) {
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'cliente', newData)
			},
			deep: true,
			immediate: true
		},
		analysis: {
			handler(newData, oldData) {
				if(!newData) {
					return
				}
				newData = JSON.stringify(newData)
				newData = JSON.parse(newData)
				this.$set(this, 'datos', {...newData.datos})
				if(this.datos.estructura.length && !this.activeClient) {
					this.activeClient = this.datos.estructura[0].id
					this.preloadPoliticas(this.datos.estructura[0])
				}

			
			},
			deep: true,
			immediate: true
		}
	},

	methods: {
		saveAnalysis() {
			let avance = this.calcAvance()
			this.save(avance)
		},
		calcAvance() {
			if(!this.datos.hasOwnProperty('estructura')) {
				return 0
			}
			let size = 0

			this.datos.estructura.forEach(item => {
				size += Object.keys(item.datos).length
			})

			let keyPercentage = 100 / size


			let total = 0
			console.log(size)
			let i = 0
			this.datos.estructura.forEach(item => {
				for (const key in item.datos) {
					if(item.datos[key] != '') {
						i += 1
						console.log(i)
						console.log(item.datos[key])
						total += keyPercentage
						console.log(total)
					} else {
						console.log('///////////////////////////////////////')
						console.log(key)
						console.log(item.datos[key])
						console.log('///////////////////////////////////////')

					}
				}
			})

			return total <= 100 ? Math.round(total) : 100
		},
		preloadPoliticas(client) {
			// let client = this.datos.estructura[0]
			let politics = client.politicas || null
			if(!politics) {
				return
			}
			politics.forEach(item => {
				let politicClient = client.datos.politicas_datos.find(p => p.nombre == item.nombre)
				if(!politicClient) {
					return
				}
				if(!politicClient.limite_anterior) {
					politicClient.limite_anterior = item.limite_anterior
				}
				if(!politicClient.limite_actual) {
					politicClient.limite_actual = item.limite_actual
				}
				if(!politicClient.dispuesto) {
					politicClient.dispuesto = item.dispuesto
				}
				if(!politicClient.propuesto) {
					politicClient.propuesto = item.propuesto
				}
				if(!politicClient.notas) {
					politicClient.notas = item.notas
				}
			})

		},
		openAddAnalysis() {
			
			this.$refs.addAnalysis.open()
		},
		submitSearch() {
			this.$set(this.modalNewAnalysis, 'selectedClient', null)
			this.$set(this.modalNewAnalysis, 'results', [])
			let results = JSON.stringify(this.pfSearch(this.modalNewAnalysis.query))
				results = JSON.parse(results)
			this.$set(this.modalNewAnalysis, 'results', results)
		},
		selectClient(c) {
			c = JSON.stringify(c)
			c = JSON.parse(c)
			this.$set(this.modalNewAnalysis, 'selectedClient', c)
		},
		openItem(event) {
			let target = event.currentTarget

			target.classList.add('open')
		},
		setClient(client) {
			let last = document.querySelector('.text.select')
			if(last) {
				last.classList.remove('select')
			}
			let target = event.currentTarget
			target.classList.add('select')

			this.$set(this.modalNewAnalysis, 'clientAnalysis', client)

		},
		resetNewAnalysis() {
			this.$set(this, 'modalNewAnalysis', {
				type: '',
				query: '',
				results: [],
				selectedClient: null,
				clientAnalysis: null
			})
		},

		addToAnalysis() {
			let vm = this
			
			this.$refs.loaderModal.open(3000, function () {

				let client = JSON.stringify(vm.modalNewAnalysis.clientAnalysis)
					client = JSON.parse(client)
				
				client.datos =  {
					politica: '',
					politicas_datos_en: '',
					politicas_divisa: '',
					fecha_vencimiento: '',
					posiciones_actuales: client.posiciones_actuales,
					politicas_datos: [
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO L/P SIN GARANTIAS REALES',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO L/P CON GARANTIAS REALES',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO FINANCIERO C/P',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO COMERCIAL',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE FIRMA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE TESORERÍA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						
						{
							negritas: true,
							nombre: 'TOTAL RIESGO CORPORATIVO',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'FINANCIACION ESPECIALIZADA',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OTROS',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: true,
							nombre: 'TOTAL GRUPO',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'ASEGURAMIENTO DE RENTA FIJA (MARCO) (**)',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO MARCO EMISOR',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE LIQUIDACIÓN - FREE DELIVERY',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RIESGO DE LIQUIDACIÓN - DELIVERY vs. PAYMENT',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OVERLIMITS, ACH',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'RENTA VARIABLE',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'ASEGURAMIENTO DE RENTA VARIABLE',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
						{
							negritas: false,
							nombre: 'OTROS RIESGOS INDIRECTOS',
							limite_anterior: '',
							limite_actual: '',
							dispuesto: '',
							propuesto: '',
							limite_nuevo: '',
							notas: '',
						},
					],

					propuesta_de_riesgo: '',

					sociedades: [
						{
							nombre: '',
							rating: '',
							fecha_ejercicio: '',
							lte_autorizado: '',
						}
					],
					detalle_de_los_techos_autorizados_con_sus_respectivas_garantias: '',
					proyecto_de_inversion: '',
					etapas: '',
					credito_relacionado: '',
					persona_de_relevancia_publica: '',
					supuestos: '',
					se_estan_incluyendo_todos_los_riesgos_del_grupo_con_la_institucion: '',


					anterior_ambito_de_conformidad: '',
					proxima_revision_de_riesgos: '',
					motivo_proxima_revision: '',
					oficina_cr: '',
					comite_de_riesgos: '',
					director_de_oficina: '',
					fecha_de_sancion: '',
					ejecutivo_unidad_gestora: '',
					nombre_del_constraste: '',
					tipo_de_cambio_usd: '',
					decision: '',
					tipo_de_cambio_a_euro: '',
					comentario_politica_de_delegacion: '',

					rentabilidad_divisa: '',
					rentabilidad_datos_en: '',
					limites: [
						{
							nombre: 'IMPORTE NOMINAL',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],
					perdida_esperada: [
						{
							nombre: '% s/Exposición',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'Importe',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],
					capital_economico: [
						{
							nombre: '% s/Exposición',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'Importe',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
						{
							nombre: 'RAR',
							autorizado: '',
							actual: '',
							propuesto: '',
						},
					],

					valoracion_y_opinion: '',

				}
	
				vm.preloadPoliticas(client)
				
				vm.datos.estructura.push(client)
				vm.activeClient = client.id
				vm.$refs.addAnalysis.close()
				vm.resetNewAnalysis()
				vm.$parent.updatedForms()

			})
		},

		seletecTab(id) {
			this.activeClient = id
		},

		removeTab(index) {
			this.datos.estructura.splice(index, 1)
			this.$parent.updatedForms()
			if(this.datos.estructura.length > 0) {
				this.activeClient = this.datos.estructura[0].id
			}else {
				this.activeClient = null
			}
		}
		
	}
}
</script>
<template>
	<div class="pb-5">
		<div class="pf-analysis__header py-3">
			<div class="d-flex align-items-center">
				<span class="pf-tag pf-tag--success">{{cliente.estado}}</span> 
				<h4 class="mb-0">{{cliente.datos.nombre}}</h4>
				<!-- <button @click="$refs.loaderModal.open(3000)">showLoader</button> -->
			</div>
			<div class="ml-auto">
				<h5 class="mb-0">Renovación del PF: {{cliente.datos.nombre}}</h5>
			</div>
		</div>
	
		<div class="d-flex align-items-center py-3">
			<div class="d-flex align-items-center">
				<h4 class="">Políticas</h4>
			</div>
			<div class="ml-auto">
				<button class="btn btn-light btn-sm rounded-0 font-weight-bold" @click="saveAnalysis"> <span class="icon-computer-folder"></span> Guardar</button>
			</div>
			
		</div>
		<div class="pf-fr-tabs" data-v-step="pf_p_0">
			<div class="pf-fr-tab" :class="{'active': activeClient == client.id}" v-for="(client, index) in datos.estructura" :key="`cliente_estructura_${index}`" @click.stop="seletecTab(client.id)">
				<span class="pf-fr-tab__title">
					{{client.nombre}}
				</span>
				<span v-if="index > 0" class="pf-fr-tab__close" @click.stop="removeTab(index)">
					X
				</span>
 
				<!-- <button @click.stop="" class="btn btn-sm btn-primary"><span class="icon-search"></span></button> -->
			</div>
			<button class="pf-fr-tab ml-1" @click="openAddAnalysis" data-v-step="pf_p_2">
				+
			</button>
		</div>


		


		<div v-for="(client, index) in datos.estructura" :key="`cliente_estructura_panel_${index}`">
			<div :id="`accordion_ppf_${index}`" v-if="activeClient == client.id" class="pf-accordion  pb-3">
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_1`"  data-v-step="pf_p_1">
						<button class="btn btn-link d-block btn-block p-0 text-left" data-toggle="collapse" :data-target="`#ppf_${index}_1`" aria-expanded="true" :aria-controls="`ppf_${index}_1`">
							Políticas de riesgo
						</button>
					</div>

					<div :id="`ppf_${index}_1`" class="collapse show " :aria-labelledby="`ppf_h_${index}_1`" :data-parent="`#accordion_ppf_${index}`">
						<div class="pt-5">
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Política (*)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.politica">
											<option value="">--Seleccione--</option>
											<option value="CRECER">CRECER</option>
											<option value="EXTINGUIR">EXTINGUIR</option>
											<option value="MANTENER">MANTENER</option>
											<option value="REDUCIR">REDUCIR</option>
										</select>
									</label>	
								</div>
								<div class="col-12 col-lg-3"></div>
								<div class="col-12 col-lg-3"></div>
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">F. Vencimiento (*)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<input class="pf-control__input pf-control--block px-1"  type="date" style="max-width: 150px" name="" v-model="client.datos.fecha_vencimiento">
									</label>	
								</div>
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Datos en (*)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.politicas_datos_en">
											<option value="">--Seleccione--</option>
											<option value="Unidades">Unidades</option>
											<option value="Miles">Miles</option>
											<option value="Millones">Millones</option>
										</select>
									</label>	
								</div>
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Divisa en (*)</span>
										<!-- TODO listas desde caratula de los cobos select -->
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.politicas_divisa">
											<option value="">--Seleccione--</option>
											<option value="Euros">Euros</option>
											<option value="Pesos Mexicanos">Pesos Mexicanos</option>
											<option value="Dólares">Dólares</option>
											<option value="Yuan">Yuan</option>
										</select>
									</label>	
								</div>
								<div class="col-12 col-lg-6"></div>
								<div class="col-12 col-lg-6 px-4">
									<h5 style="font-weight: 700; font-size: 0.9rem">(*) Se deberá rellenar al menos una fila en la parrilla</h5>
								</div>

								<div class="col-12 pt-5">
									<div style="overflow-x: auto;">
										<table class="table pf-table-th-gray table-bordered">
											<tbody>
												<tr>
													<th class="text-center py-3"></th>
													<th class="text-center py-3">LÍMITE ANTERIOR</th>
													<th class="text-center py-3">LÍMITE ACTUAL</th>
													<th class="text-center py-3">DISPUESTO</th>
													<th class="text-center py-3">LÍMITE NUEVO</th>
													<th class="text-center py-3">NOTAS</th>
												</tr>
												<tr v-for="(item, index) in client.datos.politicas_datos" :key="`politica_item_${index}`">
													<td style="width: 250px">
														<div class="d-flex align-items-center">
															<button class="btn btn-light p-1 text-primary" @click="removeShareholder(index)">
																<span class="icon-trash"></span>
															</button>
															<span class="ml-2" :class="{'font-weight-bold': item.negritas}" style="font-size: 0.9rem">{{item.nombre}}</span>
														</div>
													</td>
													<td>
														<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_anterior">
													</td>
													<td>
														<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_actual">
													</td>
													<td>
														<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.dispuesto">
													</td>
													<td>
														<input class="pf-control__input pf-control--block text-right" type="text" v-model="item.limite_nuevo">
													</td>
													<td>
														<input class="pf-control__input pf-control--block text-center" type="text" v-model="item.notas">
													</td>
												</tr>
											</tbody>
										</table>
									</div>
									<div class="d-flex flex-wrap pt-5">
										<div class="col-12 mx-auto py-2">
											<label class="pf-control d-flex">
												<span class="pf-control__label"></span>
												<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
											</label>	
											<quill-editor
											ref="myQuillEditor"
											v-model="client.datos.posiciones_actuales"
											@change="$parent.updatedForms"
											/>
										</div>	
									</div>
									<div>
										<p>(*) Campos obligatorios para realizar la propuesta</p>
										<p>(**) Los importes residuales que excedan de dicho marco computarán como marco emisor, si existieran límites aprobados disponibles.</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_2`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#ppf_${index}_2`" aria-expanded="true" :aria-controls="`ppf_${index}_2`">
							Propuesta de Riesgo
						</button>
					</div>

					<div :id="`ppf_${index}_2`" class="collapse" :aria-labelledby="`ppf_h_${index}_2`" :data-parent="`#accordion_ppf_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label"></span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.propuesta_de_riesgo"
								@change="$parent.updatedForms"
								/>
							</div>	
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_3`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#ppf_${index}_3`" aria-expanded="true" :aria-controls="`ppf_${index}_3`">
							Detalles política de riesgo
						</button>
					</div>

					<div :id="`ppf_${index}_3`" class="collapse" :aria-labelledby="`ppf_h_${index}_3`" :data-parent="`#accordion_ppf_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 col-lg-9 p-1">
								<div style="overflow-x: auto;">
									<table class="table pf-table-th-gray table-bordered">
										<tbody>
											<tr>
												<th class="text-center">SOCIEDADES</th>
												<th class="text-center">RATING</th>
												<th class="text-center">FECHA EJERCICIO</th>
												<th class="text-center">LTE. AUTORIZADO</th>
											</tr>
											<tr v-for="(sociedad, index) in client.datos.sociedades" :key="`sociedad_${index}`">
												<td>
													<div class="d-flex">
														<button class="btn btn-light p-1 text-primary" @click="removeShareholder(index)">
															<span class="icon-trash"></span>
														</button>
														<input class="pf-control__input pf-control--block" type="text" v-model="sociedad.nombre">
													</div>
												</td>
												<td style="width: 120px">
													<input type="text" class="pf-control__input pf-control--block"  name="" id="" v-model="sociedad.rating">
												</td>
												<td >
													<input class="pf-control__input pf-control--block"  name="" id="" v-model="sociedad.fecha_ejercicio">
												</td>
												<td >
													<input class="pf-control__input pf-control--block"  name="" id="" v-model="sociedad.lte_autorizado">
												</td>
											</tr>
										</tbody>
									</table>
								</div>	
							</div>
							<div class="col-12 col-lg-3 p-1">
								<div style="overflow-x: auto;">
									<table class="table pf-table-th-gray table-bordered">
										<tbody>
											<tr>
												<th class="text-center">DETALLE DE LOS TECHOS AUTORIZADOS CON SUS RESPECTIVAS GARANTIAS</th>
											</tr>
											<tr>
												<td>
													<input class="pf-control__input pf-control--block"  name="" id="" v-model="client.datos.detalle_de_los_techos_autorizados_con_sus_respectivas_garantias">
												</td>
											</tr>
										</tbody>
									</table>
								</div>	
							</div>
							<div class="col-12 p-1">
								<div class="d-flex flex-wrap">
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											PROYECTO DE INVERSIÓN:
											(SI/NO)
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.proyecto_de_inversion">
											<option value="">--Seleccione--</option>
											<option value="Si">Si</option>
											<option value="No">No</option>
										</select>
									</div>
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											ETAPAS
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.etapas">
									</div>
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											CREDITO RELACIONADO: (SI/NO)
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.credito_relacionado">
											<option value="">--Seleccione--</option>
											<option value="Si">Si</option>
											<option value="No">No</option>
										</select>
									</div>
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											SUPUESTOS
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.supuestos">
									</div>
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											PERSONA DE RELEVANCIA PÚBLICA: (SI/NO)
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.persona_de_relevancia_publica">
											<option value="">--Seleccione--</option>
											<option value="Si">Si</option>
											<option value="No">No</option>
										</select>
									</div>
									<div class="col-4 py-2 border-top">
										<p class="m-0 font-weight-bold m-0">
											¿SE ESTÁN INCLUYENDO TODOS LOS RIESGOS DEL GRUPO CON LA INSTITUCIÓN?
										</p>
									</div>
									<div class="col-2 py-2 border-top">
										<select class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.se_estan_incluyendo_todos_los_riesgos_del_grupo_con_la_institucion">
											<option value="">--Seleccione--</option>
											<option value="Si">Si</option>
											<option value="No">No</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_4`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#ppf_${index}_4`" aria-expanded="true" :aria-controls="`ppf_${index}_4`">
							Política de delegacíon
						</button>
					</div>

					<div :id="`ppf_${index}_4`" class="collapse" :aria-labelledby="`ppf_h_${index}_4`" :data-parent="`#accordion_ppf_${index}`">
						<div class="pt-5">
							<h5 class="text-primary px-4">FIJACIÓN PROGRAMA FINANCIERO</h5>
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Anterior Ámbito de Conformidad</span>
										<select  name="" class="pf-control__input pf-control--block" style="max-width: 150px;" v-model="client.datos.anterior_ambito_de_conformidad">
											<option value="">--Seleccione--</option>
											<option value="COMITE GCRC AREA">COMITE GCRC AREA</option>
											<option value="COMITE GCRC">COMITE GCRC</option>
											<option value="UCR/GCR LOCAL">UCR/GCR LOCAL</option>
											<option value="RMC-RISK MANAGEMENT COMITE">RMC-RISK MANAGEMENT COMITE</option>
											<option value="COMISION DE RIESGOS">COMISION DE RIESGOS</option>
											<option value="COMISION DELEGADA PERMANENTE">COMISION DELEGADA PERMANENTE</option>
											<option value="DELEGACIÓN LOCAL">DELEGACIÓN LOCAL</option>
											<option value="N/A (nuevo cliente)">N/A (nuevo cliente)</option>
											<option value="COMITÉ GWCC">COMITÉ GWCC</option>
											<option value="CCC">CCC</option>
											<option value="CTO">CTO</option>
											<option value="GRMC (Global Risk Management Comité)">GRMC (Global Risk Management Comité)</option>
											<option value="CTOG (Comité Téc. de op. globales)">CTOG (Comité Téc. de op. globales)</option>
											<option value="RMC LOCAL">RMC LOCAL</option>
											<option value="CTO LOCAL">CTO LOCAL</option>
											<option value="COMITE DEVISIONAL">COMITE DEVISIONAL</option>
											<option value="COMITE TERRITORIAL">COMITE TERRITORIAL</option>
											<option value="COMITÉ OFICINA">COMITÉ OFICINA</option>
										</select>
									</label>
								</div>
								<div class="col-12 col-lg-6"></div>
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Próxima Revisión de riesgo:</span>
										<input type="date" name="" class="pf-control__input pf-control--block px-1" style="max-width: 150px;"  v-model="client.datos.proxima_revision_de_riesgos">
									</label>
								</div>
								<div class="col-12 col-lg-3 px-4">
									<label class="pf-control">
										<span class="pf-control__label">Motivo Próxima Revisión:</span>
										<input type="text" name="" class="pf-control__input pf-control--block"  v-model="client.datos.motivo_proxima_revision">
									</label>
								</div>
								<div class="col-12 p-1">
									<div class="d-flex flex-wrap">
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												OFICINA/CR: 
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.oficina_cr">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												COMITÉ DE RIESGOS: 
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.comite_de_riesgos">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												DIRECTOR DE OFICINA:
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.director_de_oficina">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												FECHA DE SANCIÓN
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.fecha_de_sancion">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												EJECUTIVO/UNIDAD GESTORA
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.ejecutivo_unidad_gestora">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												NOMBRE DEL CONSTRASTE
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.nombre_del_constraste">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												TIPO  DE CAMBIO (USD):
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.tipo_de_cambio_usd">
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												DECISIÓN:
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<select class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.decision">
												<option value="">--Seleccione--</option> 
												<option value="Baja">Baja</option> 
												<option value="Aprobado">Aprobado</option> 
												<option value="Declinado">Declinado</option> 
												<option value="Rechazado">Rechazado</option> 
											</select>
										</div>
										<div class="col-4 py-2 border-top">
											<p class="m-0 font-weight-bold m-0">
												TIPO  DE CAMBIO A EURO (EUR):
											</p>
										</div>
										<div class="col-2 py-2 border-top">
											<input class="pf-control__input pf-control--block" name="" id="" v-model="client.datos.tipo_de_cambio_a_euro">
										</div>
									</div>
								</div>

								<div class="col-12">
									<div class="col-12 mx-auto py-2">
										<label class="pf-control d-flex">
											<span class="pf-control__label"></span>
											<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
										</label>	
										<quill-editor
										ref="myQuillEditor"
										v-model="client.datos.comentario_politica_de_delegacion"
										@change="$parent.updatedForms"
										/>
									</div>	
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_5`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#ppf_${index}_5`" aria-expanded="true" :aria-controls="`ppf_${index}_5`">
							Rentabilidad
						</button>
					</div>

					<div :id="`ppf_${index}_5`" class="collapse" :aria-labelledby="`ppf_h_${index}_5`" :data-parent="`#accordion_ppf_${index}`">
						<div class="pt-5">
							<div class="d-flex flex-wrap">
								<div class="col-12 col-lg-3 py-2">
									<label class="pf-control">
										<span class="pf-control__label">Divisa</span>
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.rentabilidad_divisa">
											<option value="">--Seleccione--</option>
											<option value="Euros">Euros</option>
											<option value="Pesos Mexicanos">Pesos Mexicanos</option>
											<option value="Dólares">Dólares</option>
											<option value="Yuan">Yuan</option>
										</select>
									</label>	
								</div>
								<div class="col-12 col-lg-3 py-2">
									<label class="pf-control">
										<span class="pf-control__label">Datos en</span>
										<select class="pf-control__input pf-control--block" name="" v-model="client.datos.rentabilidad_datos_en">
											<option value="">--Seleccione--</option>
											<option value="Unidades">Unidades</option>
											<option value="Miles">Miles</option>
											<option value="Millones">Millones</option>
										</select>
									</label>	
								</div>

								<div class="col-12">
									<div style="overflow-x: auto;">
										<table class="table pf-table-th-gray table-bordered">
											<tr>
												<td colspan="4" class="py-0">
													<span class="font-weight-bold">LÍMITES</span>
												</td>
											</tr>
											<tr>
												<th></th>
												<th class="text-center">AUTORIZADO</th>
												<th class="text-center">ACTUAL</th>
												<th class="text-center">PROPUESTO</th>
											</tr>
											<tr v-for="(limite, index) in client.datos.limites" :key="`limite_${index}`">
												<td class="py-1">
													<div class="d-flex align-items-center">
														<button class="btn btn-light p-1 text-primary">
															<span class="icon-trash"></span>
														</button>
														<span class="font-weight-bold ml-2">{{limite.nombre}}</span>
													</div>
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="limite.autorizado">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="limite.actual">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="limite.propuesto">
												</td>
											</tr>
											<tr>
												<th colspan="4" class="py-0">
													<span class="font-weight-bold">PÉRDIDA ESPERADA</span>
												</th>
											</tr>
											<tr v-for="(perdida, index) in client.datos.perdida_esperada" :key="`perdida_${index}`">
												<td class="py-1">
													<div class="d-flex align-items-center">
														<button class="btn btn-light p-1 text-primary">
															<span class="icon-trash"></span>
														</button>
														<span class="font-weight-bold ml-2">{{perdida.nombre}}</span>
													</div>
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="perdida.autorizado">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="perdida.actual">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="perdida.propuesto">
												</td>
											</tr>
											<tr>
												<th colspan="4" class="py-0">
													<span class="font-weight-bold">CAPITAL ECONÓMICO</span>
												</th>
											</tr>
											<tr v-for="(capital, index) in client.datos.capital_economico" :key="`capital_${index}`">
												<td class="py-1">
													<div class="d-flex align-items-center">
														<button class="btn btn-light p-1 text-primary">
															<span class="icon-trash"></span>
														</button>
														<span class="font-weight-bold ml-2">{{capital.nombre}}</span>
													</div>
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="capital.autorizado">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="capital.actual">
												</td>
												<td class="py-1">
													<input class="pf-control__input pf-control--block" type="text" v-model="capital.propuesto">
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-1" :id="`ppf_h_${index}_6`">
						<button class="btn btn-link d-block btn-block p-0 text-left collapsed" data-toggle="collapse" :data-target="`#ppf_${index}_6`" aria-expanded="true" :aria-controls="`ppf_${index}_6`">
							Valoración y opinión
						</button>
					</div>
					<div :id="`ppf_${index}_6`" class="collapse" :aria-labelledby="`ppf_h_${index}_6`" :data-parent="`#accordion_ppf_${index}`">
						<div class="d-flex flex-wrap pt-5">
							<div class="col-12 mx-auto py-2">
								<label class="pf-control d-flex">
									<span class="pf-control__label"></span>
									<button class="pf-btn btn btn-primary btn-sm ml-3"><span class="icon-clip"></span></button>
								</label>	
								<quill-editor
								ref="myQuillEditor"
								v-model="client.datos.valoracion_y_opinion"
								@change="$parent.updatedForms"
								/>
							</div>	
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="pf-controls-flow">
			<div class="container">
				<div class="d-flex">
					<div class="ml-auto pf-controls-flow__button">
						<button class="btn btn-light btn-sm rounded-0 font-weight-bold"  @click="saveAnalysis"> <span class="icon-computer-folder"></span> Guardar</button>
					</div>
				</div>
			</div>
		</div>
		<pf-modal ref="addAnalysis" :show-close="true" title="Estructura Grupo" class="pf-modal--lg" >
			<div class="p-3" style="min-height: 800px">
				<form @submit.prevent="submitSearch">
					<div class="d-flex flex-wrap border-bottom">
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Búsqueda por</span>
								<select class="pf-control__input pf-control--block">
									<option value="">--Seleccione--</option>
									<option value="Supragrupo">Supragrupo</option>
									<option value="Grupo">Grupo</option>
									<option value="Subgrupo">Subgrupo</option>
									<option value="Cliente/Filial">Cliente/Filial</option>
								</select>
							</label>
						</div>
					
						<div class="col-12 col-lg-9"></div>
					
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">N° Cliente/Grupo</span>
								<input type="text" class="pf-control__input pf-control--block">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<label class="pf-control">	
								<span class="pf-control__label">Nombre</span>
								<input type="text" class="pf-control__input pf-control--block" v-model="modalNewAnalysis.query">
							</label>
						</div>
						<div class="col-12 col-lg-3">
							<button type="submit" class="btn btn-sm btn-primary" style="font-weight: 300">Buscar</button>
						</div>
					</div>
				
				</form>

					<div class="pt-3" v-if="modalNewAnalysis.results.length && !modalNewAnalysis.selectedClient"> 
						<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="mr-3">Buscar:</span><input type="text" class="border-none">
								</div>
							</div>
						</div>
						<div>
							<table class="table table-borderless w-100">
								<tbody style="font-size: 0.8em" class="text-center">
									<tr>
										<th class="pf-section-gradient py-2" style="width: 2rem"></th>
										<th class="pf-section-gradient py-2 text-left">NOMBRE</th>
										<th class="pf-section-gradient py-2 text-left">CODIGO/CIF</th>
									</tr>
									<tr class="pointer" v-for="(cliente, index) in modalNewAnalysis.results" :key="`cliente_${cliente.id}_${index}`" @click="selectClient(cliente)">
										<td class="px-1">
											<span class="icon-group text-primary" style="font-size: 1.3rem"></span>
										</td>
										<td class="text-left">
											{{cliente.nombre}}
										</td>
										<td class="text-left">
											{{cliente.cif}}
										</td>
									</tr>
								</tbody>
							
							</table>

							<div class="pf-section-gradient mb-2">
							<div class="d-flex">
								<div class="ml-auto d-flex align-items-end">
									<span class="px-1 small">Primero</span>
									<span class="px-1 small">Anterior</span>
									<span class="px-1 small">1</span>
									<span class="px-1 small">Siguiente</span>
									<span class="px-1 small">Último</span>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div v-if="modalNewAnalysis.selectedClient" class="diagram" style="min-height: 500px">
						<div class="diagram__item">
							<div class="diagram__title diagram__title--top" @click.prevent="openItem">
								<span class="icon-group text-primary" style="font-size: 1.3rem"></span> <span class="text" @click.stop="setClient(modalNewAnalysis.selectedClient)"><b>{{modalNewAnalysis.selectedClient.nombre}}</b></span> 
							</div>
							<div class="diagram__item">
								<div class="diagram__title diagram__title--top" @click.prevent="openItem">
									<span class="icon-plus-symbol-button text-primary"></span> <b>Ver todos los participes</b>
								</div>
								<div class="diagram__item" v-for="(filial, index) in modalNewAnalysis.selectedClient.hijos" :key="`filial_${filial.id}_${index}`">
									<div class="diagram__title">
										<span class="icon-user text-primary"></span> <span class="text" @click.stop="setClient(filial)">{{filial.nombre}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div v-if="modalNewAnalysis.clientAnalysis" class="mt-5 py-3 border-top" style="color: #000; font-size: 0.8em">
						<div class="d-flex flex-wrap">
							<div class="col-12 col-md-6">
								Seleccionado: <b>{{modalNewAnalysis.clientAnalysis.nombre}}</b>
							</div>
							<div class="col-12 col-md-3">
								Nivel: <b>{{modalNewAnalysis.clientAnalysis.tipo === 'Grupo' ? 'Grupo' : 'Partícipe'}}</b>
							</div>
							<div class="col-12 col-md-3">
								Entidad: <b>{{modalNewAnalysis.clientAnalysis.entidad}}</b>
							</div>
						</div>

						<div class="d-flex justify-content-center flex-wrap mt-4">
							<div class="col-6 col-md-3">
								<button class="btn btn-primary btn-block rounded w-100" style="font-weight: 300;" @click="addToAnalysis">
									Agregar
								</button>
							</div>
						</div>
					</div>
			</div>
		</pf-modal>
		<pf-modal ref="loaderModal" title="Espere">
			<div class="text-center p-2">
				<p>Realizando la operación seleccionada</p>
				<PfLoader />
			</div>
		</pf-modal>
	</div>
</template>